import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useMe } from './auth/useAuth';
import LoginPage from './pages/LoginPage';
import AppLayout from './components/AppLayout';
import ArticleListPage from './pages/ArticleListPage';
import ArticleEditPage from './pages/ArticleEditPage';
import MediaPage from './pages/MediaPage';
import UsersPage from './pages/UsersPage';
import AccountPage from './pages/AccountPage';
import ContestArchivePage from './pages/ContestArchivePage';

/** 路由 + 登入守門。未登入 → 登入頁；已登入 → 後台外殼。 */
export default function App() {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!me) return <LoginPage />;

  return (
    <BrowserRouter>
      <AppLayout me={me}>
        <Routes>
          <Route path="/articles" element={<ArticleListPage />} />
          <Route path="/articles/:id/edit" element={<ArticleEditPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/contests" element={<ContestArchivePage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="*" element={<Navigate to="/articles" replace />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
}
